// Exporting the following namespace for clients of User Address to consume
export var Commands;
(function (_Commands) {
  var CommandNames = /*#__PURE__*/function (CommandNames) {
    CommandNames["RESET_FIELDS"] = "RESET_FIELDS";
    CommandNames["VERIFY_ADDRESS"] = "VERIFY_ADDRESS";
    CommandNames["REAUTHORIZE"] = "REAUTHORIZE";
    CommandNames["SAVE_CONFIGS"] = "SAVE_CONFIGS";
    return CommandNames;
  }({});
  _Commands.CommandNames = CommandNames;
})(Commands || (Commands = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/CommandState/CommandState.types.js
// module id = 1490
// module chunks = 11